<script lang="ts">
	import { createForm } from '../../../utils/form-utils';
	import { Button } from '../../Button';
	import type { DialogStores } from '../../Dialog';
	import { Dialog } from '../../Dialog';
	import { Input } from '../../Input';

	import { checkUrl } from './utils/checkUrl/checkUrl';
	import {
		DropzoneUrlDialogValidationSchema,
		DropzoneUrlDialogFieldNames
	} from './utils/dropzoneUrlDialogSchema/dropzoneUrlDialogSchema';

	let { maxSize, accept, dataCy, dialogStores, onSubmit }: Props = $props();

	interface Props {
		maxSize: number;
		accept: string[];
		dataCy: string;
		dialogStores: DialogStores;
		onSubmit: (url: string) => void;
	}

	let error = $state('');
	let submitting = $state(false);

	const { form, handleBlur, getFieldErrorMessage } = createForm({
		schema: DropzoneUrlDialogValidationSchema,
		initialValues: {
			url: ''
		}
	});

	let inputError = $derived(getFieldErrorMessage(DropzoneUrlDialogFieldNames.Url) || error);

	const handleSubmit = async (e: Event) => {
		e.preventDefault();
		error = '';
		const url = form[DropzoneUrlDialogFieldNames.Url].value;

		try {
			await checkUrl(url, accept, maxSize);
			dialogStores.states.open.set(false);
			onSubmit(form[DropzoneUrlDialogFieldNames.Url].value);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			error = e.message;
		} finally {
			submitting = false;
		}
	};
</script>

<Dialog
	{dialogStores}
	{dataCy}
	class="xs:max-w-[26rem] max-w-[20rem] p-[1.5rem] pt-[1.25rem] sm:p-[1.5rem] sm:pt-[1rem]"
>
	<form onsubmit={handleSubmit} class="pt-2">
		<Input
			dataCy={`${dataCy}-dialog-file-url`}
			label="Import file from URL"
			required={form[DropzoneUrlDialogFieldNames.Url].required}
			placeholder="Enter file URL"
			name={DropzoneUrlDialogFieldNames.Url}
			id={DropzoneUrlDialogFieldNames.Url}
			type="text"
			error={inputError}
			bind:value={form[DropzoneUrlDialogFieldNames.Url].value}
			onblur={handleBlur(DropzoneUrlDialogFieldNames.Url)}
		/>

		<div class="mt-6 flex justify-end">
			<Button dataCy={`${dataCy}-dialog-submit`} size="md" loading={submitting}>submit</Button>
		</div>
	</form>
</Dialog>
